module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Dinner-d38fe99f45672674874c11076b5bf92e.svg";